import Vue from "vue";

import App from "./App.vue";
import Router from "vue-router";

import Containers from "./Containers.vue";
import Werven from "./Werven.vue";
import Vrachtwagens from "./Vrachtwagens.vue";
import Klanten from "./Klanten.vue";
import Chauffeurs from "./Chauffeurs.vue";
import Overzicht from "./Overzicht.vue";
import Overzicht2 from "./Overzicht2.vue";
import Bestellingen from "./Bestellingen.vue";
import Leveringen from "./Leveringen.vue";
import Stortplaatsen from "./Stortplaatsen.vue";
import Instellingen from "./Instellingen.vue";
import Gebruikers from "./Gebruikers.vue";
import Afvalproducten from "./Afvalproducten.vue";
import Leveringsproducten from "./Leveringsproducten.vue";
import TransportZones from "./TransportZones.vue";
import ResetPassword from "./ResetPassword.vue";
import NewPassword from "./NewPassword.vue";
import Login from "./Login.vue";
import Logout from "./Logout.vue";
import Test from "./Test.vue";

import store from "./store";

import "vue-search-select/dist/VueSearchSelect.css";

import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

Vue.use(VueGoodTablePlugin);

Vue.config.productionTip = false;

import VCalendar from "v-calendar";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";

Vue.use(VCalendar);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

const moment = require("moment");
require("moment/locale/nl");

Vue.use(require("vue-moment"), {
  moment,
});

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import axios from "axios";

Vue.use(Router);

const router = new Router({
  routes: [
    { path: "/bestellingen", component: Bestellingen },
    { path: "/leveringen", component: Leveringen },
    { path: "/klanten", component: Klanten },
    { path: "/werven", component: Werven },
    { path: "/containers", component: Containers },
    { path: "/chauffeurs", component: Chauffeurs },
    { path: "/vrachtwagens", component: Vrachtwagens },
    { path: "/stortplaatsen", component: Stortplaatsen },
    { path: "/instellingen", component: Instellingen },
    {
      path: "/overzicht",
      component: Overzicht,
      meta: {
        admin: true,
      },
    },
    { path: "/overzicht2", component: Overzicht2 },
    { path: "/gebruikers", component: Gebruikers },
    { path: "/afvalproducten", component: Afvalproducten },
    { path: "/leveringsproducten", component: Leveringsproducten },
    { path: "/transportzones", component: TransportZones },
    { path: "/wachtwoord-vergeten", component: ResetPassword },
    { path: "/nieuw-wachtwoord", component: NewPassword },
    { path: "/login", component: Login },
    { path: "/logout", component: Logout },
    { path: "/test", component: Test },
  ],
  mode: "history",
});

router.beforeEach((to, from, next) => {
  const loggedIn = JSON.parse(localStorage.getItem("user"));

  if (loggedIn !== null) {
    const userType = loggedIn.type;

    if (to.matched.some((route) => route.meta.admin)) {
      if (userType == "Administrator") {
        router.push({ path: "/overzicht2" });
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    if (to.path !== "/login" && to.path !== "/wachtwoord-vergeten" && to.path !== "/nieuw-wachtwoord") {
      router.push({ path: "/login" });
    } else {
      next();
    }
  }
});

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

new Vue({
  render: (h) => h(App),
  router,
  store,
  created() {
    const userString = localStorage.getItem("user");
    if (userString) {
      const userData = JSON.parse(userString);
      userData["type"] = parseJwt(userData.token).utype;

      this.$store.commit("SET_USER_DATA", userData);
    }

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        console.log("response error", error);
        if (error.response.status == 401) {
          this.$store.dispatch("logout");
        }
        return Promise.reject(error);
      }
    );
  },
}).$mount("#app");
